import { TextCardContent } from "./components/TextCardContent";
import { CardChildrenProps, ChildrenTypeEnum } from "./types";
import SunburstChart, { SunburstChartProps } from "./components/SunBurstChart";
import EvolutionChart, {
  EvolutionChartProps,
} from "./components/EvolutionChart";
import { TextCardContentProps } from "./components/TextCardContent";
import TreeChart, { TreeChartProps } from "./components/TreeChart";
import {
  WeatherInfoCardContent,
  WeatherInfoCardContentProps,
} from "./components/WeatherInfoCardContent";
import AccumulatedEnergyChart, {
  AccumulatedEnergyProps,
} from "./components/metas/AccumulatedEnergyChart";
import LossDiagramChart, {
  LossDiagramProps,
} from "./components/metas/LossDiagramChart";
import ProductivityChart, {
  ProductivityProps,
} from "./components/metas/ProductivityChart";
import AccumulatedCertifiedEnergyChart, {
  AccumulatedCertifiedEnergyProps,
} from "./components/metas/AccumulatedCertifiedEnergyChart";
import ParetoChart, { ParetoChartProps } from "./components/ParetoChart";
import TrackerChart, { TrackerChartProps } from "./components/TrackerChart";
import HeatmapChart, { HeatmapChartProps } from "./components/HeatmapChart";

export function getCardChildrenByTypeAndProps(
  type: ChildrenTypeEnum,
  props: CardChildrenProps,
  cardId?: string
): React.ReactNode {
  const childrenProps = cardId ? { ...props, cardId: cardId } : props;
  const typeIsValid = Object.values(ChildrenTypeEnum).includes(type);
  if (!typeIsValid) {
    console.error(`Tipo de children não encontrado: ${ChildrenTypeEnum[type]}`);
  }

  const propsIsValid = checkObjectType(type, childrenProps);
  if (!propsIsValid) {
    console.error(
      `Props inválidas para o tipo ${ChildrenTypeEnum[type]
      }, props: ${JSON.stringify(childrenProps)}`
    );
  }
  switch (type) {
    case ChildrenTypeEnum.TextCard: {
      if (propsIsValid) {
        const correctProps = childrenProps as TextCardContentProps;
        return <TextCardContent {...correctProps} />;
      }
      break;
    }
    case ChildrenTypeEnum.EvolutionChart: {
      if (propsIsValid) {
        const correctProps = childrenProps as EvolutionChartProps;
        return <EvolutionChart {...correctProps} />;
      }
      break;
    }
    case ChildrenTypeEnum.SunburstChart: {
      if (propsIsValid) {
        const correctProps = childrenProps as SunburstChartProps;
        return <SunburstChart {...correctProps} />;
      }
      break;
    }
    case ChildrenTypeEnum.TreeChart: {
      if (propsIsValid) {
        const correctProps = childrenProps as TreeChartProps;
        return <TreeChart {...correctProps} />;
      }
      break;
    }
    case ChildrenTypeEnum.WeatherCard: {
      if (propsIsValid) {
        const correctProps = childrenProps as WeatherInfoCardContentProps;
        return <WeatherInfoCardContent {...correctProps} />;
      }
      break;
    }
    case ChildrenTypeEnum.AccumulatedEnergyChart: {
      if (propsIsValid) {
        const correctProps = childrenProps as AccumulatedEnergyProps;
        return <AccumulatedEnergyChart {...correctProps} />;
      }
      break;
    }
    case ChildrenTypeEnum.LossDiagramChart: {
      if (propsIsValid) {
        const correctProps = childrenProps as LossDiagramProps;
        return <LossDiagramChart {...correctProps} />;
      }
      break;
    }
    case ChildrenTypeEnum.AccumulatedCertifiedEnergyChart: {
      if (propsIsValid) {
        const correctProps = childrenProps as AccumulatedCertifiedEnergyProps;
        return <AccumulatedCertifiedEnergyChart {...correctProps} />;
      }
      break;
    }
    case ChildrenTypeEnum.ProductivityChart: {
      if (propsIsValid) {
        const correctProps = childrenProps as ProductivityProps;
        return <ProductivityChart {...correctProps} />;
      }
      break;
    }
    case ChildrenTypeEnum.ParetoChart: {
      if (propsIsValid) {
        const correctProps = childrenProps as ParetoChartProps;
        return <ParetoChart {...correctProps} />;
      }
      break;
    }

    case ChildrenTypeEnum.TrackerChart: {
      if (propsIsValid) {
        const correctProps = childrenProps as TrackerChartProps;
        return <TrackerChart {...correctProps} />;
      }
      break;
    }
    case ChildrenTypeEnum.HeatmapChart: {
      if (propsIsValid) {
        const correctProps = childrenProps as HeatmapChartProps;
        return <HeatmapChart {...correctProps} />;
      }
      break;
    }
  }
}

export function checkObjectType(
  type: ChildrenTypeEnum,
  props: CardChildrenProps
): boolean {
  switch (type) {
    case ChildrenTypeEnum.TextCard:
      return isTextCardContent(props);
    case ChildrenTypeEnum.EvolutionChart:
      return isEvolutionChartProps(props);
    case ChildrenTypeEnum.SunburstChart:
      return isSunburstChartProps(props);
    case ChildrenTypeEnum.TreeChart:
      return isTreeChartProps(props);
    case ChildrenTypeEnum.WeatherCard:
      return isWeatherInfoCardContent(props);
    case ChildrenTypeEnum.AccumulatedEnergyChart:
      return isAccumulatedEnergyProps(props);
    case ChildrenTypeEnum.LossDiagramChart:
      return isLossDiagramProps(props);
    case ChildrenTypeEnum.AccumulatedCertifiedEnergyChart:
      return isAccumulatedCertifiedEnergyProps(props);
    case ChildrenTypeEnum.ProductivityChart:
      return isProductivityProps(props);
    case ChildrenTypeEnum.ParetoChart:
      return isParettoProps(props);
    case ChildrenTypeEnum.TrackerChart:
      return isTrackerProps(props);
    case ChildrenTypeEnum.HeatmapChart:
      return isHeatmapProps(props);
    default:
      return false;
  }
}

function isTextCardContent(
  props: CardChildrenProps
): props is TextCardContentProps {
  if (typeof props !== "object" || props === null) {
    return false;
  }

  const { title, value: value, secondaryData } = props as TextCardContentProps;
  if (title) {
    if (typeof title !== "string") return false;
  }
  if (value) {
    if (typeof value !== "string") return false;
  }

  if (secondaryData !== undefined) {
    if (!Array.isArray(secondaryData)) {
      return false;
    }

    for (const item of secondaryData) {
      if (typeof item !== "object" || item === null) {
        return false;
      }
      if (item.title) {
        if (typeof item.title !== "string") {
          return false;
        }
      }
      if (item.value) {
        if (typeof item.value !== "string") {
          return false;
        }
      }
    }
  }

  return true;
}

function isEvolutionChartProps(
  props: CardChildrenProps
): props is EvolutionChartProps {
  if (typeof props !== "object" || props === null) {
    return false;
  }

  const { data } = props as EvolutionChartProps;

  if (typeof data !== "object" || data === null) {
    return false;
  }

  if (
    (data.evolution && !Array.isArray(data.evolution)) ||
    (data.irradiancia && !Array.isArray(data.irradiancia)) ||
    (data.potenciaAtivaAtMinutes && !Array.isArray(data.potenciaAtivaAtMinutes))
  ) {
    return false;
  }

  return true;
}

function isTreeChartProps(props: CardChildrenProps): props is TreeChartProps {
  if (typeof props !== "object" || props === null) {
    return false;
  }

  const { title, data } = props as TreeChartProps;

  if (typeof data !== "object" || data === null) {
    return false;
  }

  if (title !== undefined && typeof title !== "string") {
    return false;
  }

  // Perform type checks for TreeChartData

  return true;
}

function isWeatherInfoCardContent(
  props: CardChildrenProps
): props is WeatherInfoCardContentProps {
  if (typeof props !== "object" || props === null) {
    return false;
  }

  const { weather } = props as WeatherInfoCardContentProps;

  if (typeof weather !== "object" || weather === null) {
    return false;
  }

  return true;
}
function isSunburstChartProps(
  props: CardChildrenProps
): props is SunburstChartProps {
  if (typeof props !== "object" || props === null) {
    return false;
  }

  const { data } = props as SunburstChartProps;

  if (typeof data !== "object" || data === null) {
    return false;
  }

  return true;
}

function isAccumulatedEnergyProps(
  props: CardChildrenProps
): props is AccumulatedEnergyProps {
  if (typeof props !== "object" || props === null) {
    return false;
  }

  const { data } = props as AccumulatedEnergyProps;

  if (typeof data !== "object" || data === null) {
    return false;
  }

  return true;
}

function isLossDiagramProps(
  props: CardChildrenProps
): props is LossDiagramProps {
  if (typeof props !== "object" || props === null) {
    return false;
  }

  const { data } = props as LossDiagramProps;

  if (typeof data !== "object" || data === null) {
    return false;
  }

  if (
    typeof data.energiaIdeal !== "number" ||
    typeof data.perdaNoCircuito !== "number" ||
    typeof data.perdaDoTrafo !== "number" ||
    typeof data.perdaDosInversores !== "number" ||
    typeof data.perdaPorIndisponibilidade !== "number" ||
    typeof data.outrasPerdas !== "number" ||
    typeof data.energiaGerada !== "number"
  ) {
    return false;
  }

  return true;
}

function isAccumulatedCertifiedEnergyProps(
  props: CardChildrenProps
): props is AccumulatedCertifiedEnergyProps {
  if (typeof props !== "object" || props === null) {
    return false;
  }

  const { data } = props as AccumulatedCertifiedEnergyProps;

  if (typeof data !== "object" || data === null) {
    return false;
  }
  if (
    !Array.isArray(data.generatedEnergy) ||
    (!Array.isArray(data.pFifty) && typeof data.pFifty !== "number") ||
    (!Array.isArray(data.pNinety) && typeof data.pFifty !== "number") ||
    (!Array.isArray(data.pNinetyFive) && typeof data.pFifty !== "number") ||
    (!Array.isArray(data.pSeventyFive) && typeof data.pFifty !== "number")
  ) {
    return false;
  }

  return true;
}

function isProductivityProps(
  props: CardChildrenProps
): props is ProductivityProps {
  if (typeof props !== "object" || props === null) {
    return false;
  }

  const { data } = props as ProductivityProps;

  if (typeof data !== "object" || data === null) {
    return false;
  }

  if (
    (data.generatedEnergy && !Array.isArray(data.generatedEnergy)) ||
    (data.irradiance && !Array.isArray(data.irradiance)) ||
    (data.predictedEnergy && !Array.isArray(data.predictedEnergy)) ||
    (data.predictedIrradianceMonths &&
      !Array.isArray(data.predictedIrradianceMonths))
  ) {
    return false;
  }

  return true;
}

function isParettoProps(props: CardChildrenProps): props is ParetoChartProps {
  if (typeof props !== "object" || props === null) {
    return false;
  }

  const { data } = props as ParetoChartProps;

  if (data.alarms && !Array.isArray(data.alarms)) {
    return false;
  }

  return true;
}
function isTrackerProps(props: CardChildrenProps): props is TrackerChartProps {
  if (typeof props !== "object" || props === null) {
    return false;
  }

  const { data } = props as TrackerChartProps;

  if (data.trackers && !Array.isArray(data.trackers)) {
    return false;
  }

  return true;
}
function isHeatmapProps(props: CardChildrenProps): props is HeatmapChartProps {
  if (typeof props !== "object" || props === null) {
    return false;
  }

  const { data } = props as HeatmapChartProps;

  if (data.inversores && !Array.isArray(data.inversores)) {
    return false;
  }

  return true;
}
